// This config is a representation of the SynthKit.js drum kit. It is used to create the drum kit in the SynthKitEngine.js.

export const SynthKitConfig = {
  id: "DefaultSynthKitConfig",
  name: "Default Synth Kit Config",
  lastModified: Date.now(),
  config: {
    Kick: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.2,
            frequency: 80,
            waveType: 'triangle',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 50, time: 0.2}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'oscillator',
            id: 'oscillator2',
            duration: 0.2,
            frequency: 120,
            waveType: 'sine',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 90, time: 0.2}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
    },
    Snare: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'snareOsc',
            duration: 0.2,
            frequency: 310,
            waveType: 'triangle',
            connectsTo: ['snareOscEnvelope']
          },
          {
            type: 'bufferSource',
            id: 'snareNoise',
            duration: 0.2,
            bufferSizeFactor: 2,
            connectsTo: ['noiseFilter']
          },
          {
            type: 'biquadFilter',
            id: 'noiseFilter',
            filterType: 'highpass',
            frequency: 2000,
            Q: 0,
            gain: 0,
            connectsTo: ['snareNoiseEnvelope']
          },
          {
            type: 'gain',
            id: 'snareNoiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'snareOscEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      rim: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'snareOsc',
            duration: 0.2,
            frequency: 310,
            waveType: 'sawtooth',
            connectsTo: ['snareOscEnvelope']
          },
          {
            type: 'bufferSource',
            id: 'snareNoise',
            duration: 0.2,
            bufferSizeFactor: 2,
            connectsTo: ['noiseFilter']
          },
          {
            type: 'biquadFilter',
            id: 'noiseFilter',
            filterType: 'highpass',
            frequency: 2000,
            Q: 0,
            gain: 0,
            connectsTo: ['snareNoiseEnvelope']
          },
          {
            type: 'gain',
            id: 'snareNoiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'snareOscEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    HiHat: {
      bow: {
        maxDuration: 2.2,
        minDuration: 0.1,
        toolChain: [
          {
            type: 'bufferSource',
            id: 'hiHatNoise',
            duration: 0.2,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 3,
            gain: 0,
            connectsTo: ['highpass']
          },
          {
            type: 'biquadFilter',
            id: 'highpass',
            filterType: 'highpass',
            frequency: 2000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      edge: {
        maxDuration: 2.2,
        minDuration: 0.1,
        toolChain: [
          {
            type: 'bufferSource',
            id: 'hiHatNoise',
            duration: 0.2,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 3,
            gain: 0,
            connectsTo: ['highpass']
          },
          {
            type: 'biquadFilter',
            id: 'highpass',
            filterType: 'highpass',
            frequency: 2000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    Tom1: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 220,
            waveType: 'sine',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 210, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      rim: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 220,
            waveType: 'triangle',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 210, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
    },
    Tom2: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 205,
            waveType: 'sine',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 195, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      rim: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 205,
            waveType: 'triangle',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 195, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
    },
    Tom3: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 195,
            waveType: 'sine',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 185, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      rim: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 195,
            waveType: 'triangle',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 185, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
    },
    Tom4: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 180,
            waveType: 'sine',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 170, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      rim: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 180,
            waveType: 'triangle',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 170, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
    },
    Tom5: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 160,
            waveType: 'sine',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 145, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      rim: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.3,
            frequency: 160,
            waveType: 'triangle',
            settings: [
              {name: "exponentialRampToValueAtTime", frequency: 145, time: 0.3}
            ],
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
    },
    Crash1: {
      bell: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'crashNoise',
            duration: 1,
            bufferSizeFactor: 16,
            connectsTo: ['bandpass','bandpass2','highpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 9000,
            Q: 10,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass2',
            filterType: 'bandpass',
            frequency: 11000,
            Q: 10,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'biquadFilter',
            id: 'highpass',
            filterType: 'highpass',
            frequency: 2000,
            Q: 10,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'crashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      bow: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'crashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'crashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      edge: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'crashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'crashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    Crash2: {
      bell: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'crashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'crashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      bow: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'crashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'crashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      edge: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'crashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'crashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    Ride: {
      edge: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'rideEdgeNoise',
            duration: 1,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 8000,
            Q: 0.5,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      bow: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'rideBowNoise',
            duration: 1,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 6000,
            Q: 0.5,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      bell: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'rideBellNoise',
            duration: 1,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 4000,
            Q: 0.5,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    Splash1: {
      bow: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'splashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'splashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      edge: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'splashNoise',
            duration: 1,
            bufferSizeFactor: 8,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 10000,
            Q: 0,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'oscillator',
            id: 'splashTone',
            duration: 1,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['toneEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
          {
            type: 'gain',
            id: 'toneEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    China1: {
      bow: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'hiHatNoise',
            duration: 1.1,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 6000,
            Q: 0.5,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1.1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      },
      edge: {
        toolChain: [
          {
            type: 'bufferSource',
            id: 'hiHatNoise',
            duration: 1.1,
            bufferSizeFactor: 2,
            connectsTo: ['bandpass']
          },
          {
            type: 'biquadFilter',
            id: 'bandpass',
            filterType: 'bandpass',
            frequency: 6000,
            Q: 0.5,
            gain: 0,
            connectsTo: ['noiseEnvelope']
          },
          {
            type: 'gain',
            id: 'noiseEnvelope',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 1.1}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    },
    Cowbell: {
      head: {
        toolChain: [
          {
            type: 'oscillator',
            id: 'oscillator1',
            duration: 0.2,
            frequency: 400,
            waveType: 'sine',
            connectsTo: ['gain1']
          },
          {
            type: 'gain',
            id: 'gain1',
            gain: 1,
            settings: [
              {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.2}
            ],
            connectsTo: ['MainPanOut']
          },
        ]
      }
    }
  }
}